/**
 * LEGACY-ONLY. Renderiza documentos con design_version='legacy' (anteriores al
 * diseño lowcode). Los documentos nuevos se renderizan con TemplateRenderer
 * (motor lowcode). No usar para documentos nuevos. Ver PDF/TemplateEngine/resolveDocDesign.js.
 */
import { Document, StyleSheet, View, Text } from '@react-pdf/renderer';
import dayjs from 'libs/dayjs';
import React from 'react';
import PageA4 from '../Elements/Pages/PageA4';
import Table from '../Elements/Table/Table';
import P from '../Elements/Text/P';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import OrderData from './OrderData';
import H1 from 'PDF/Elements/Text/H1';
import SignatureBlock from 'PDF/Signatures';
import { API_PATH } from 'config';

const styles = StyleSheet.create({
  page: {
    paddingBottom: '4cm',
    paddingTop: '4cm',
    paddingHorizontal: '1.5cm',
    backgroundColor: '#ffffff',
    minHeight: '100vh',
    width: '100%',
  },
  section: {
    marginBottom: '1.5cm',
    padding: '0.8cm',
    backgroundColor: '#ffffff',
    borderRadius: '0.3cm',
    border: '1px solid #e8e8e8',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  },
  body: {
    flex: 1,
    paddingTop: '0.5cm',
  },
  titleContainer: {
    fontSize: '18px',
    fontFamily: 'Helvetica-Bold',
    color: '#ffffff',
    backgroundColor: '#548235',
    paddingVertical: '0.6cm',
    paddingHorizontal: '1cm',
    textAlign: 'center',
    borderRadius: '0.3cm',
    marginBottom: '1cm',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  dataContainer: {
    marginBottom: '1.5cm',
  },
  signaturesContainer: {
    marginTop: '1.5cm',
  },
  header: {
    width: '100vw',
    position: 'absolute',
    top: '0px',
    left: '0px',
    right: '0px',
    height: '3.5cm',
    backgroundColor: '#ffffff',
    borderBottom: '2px solid #548235',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: '1.5cm',
    paddingVertical: '0.4cm',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  footer: {
    position: 'absolute',
    bottom: '0px',
    left: '0px',
    right: '0px',
    width: '100vw',
    height: '3.5cm',
    backgroundColor: '#f8f9fa',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: '0.6cm',
    boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
  },
});
const columns = [
  {
    width: '5%',
    title: 'N°',
    key: 'number',
  },
  {
    width: '25%',
    title: 'Equipos',
    key: 'elevator',
  },
  {
    width: '70%',
    title: 'Descripción',
    key: 'description',
  },

  // {
  //   width: '25%',
  //   title: 'Finaliza',
  //   key: 'date_finish',
  // },
];
function OrderDocument(props) {
  const { data, config } = props;
  let { items } = props;
  items = items.map((item, index) => ({
    ...item,
    date_finish: dayjs(item.date_finish).format('YYYY-MM-DD HH:MM'),
    number: index,
  }));
  const {
    specialist_signature: specialistSignature,
    recepcionist_signature: recepcionistSignature,
    specialist_name: specialistName,
    recepcionist_name: recepcionistName,
    recepcionist_charge: recepcionistCharge,
    specialist_cargo: specialistCargo,
    specialist_especialidad: specialistEspecialidad,
    specialist_otros: specialistOtros,
  } = data;

  return (
    <Document>
      <PageA4 style={styles.page}>
        {/* Header fijo */}
        <View style={styles.header} fixed>
          <Header config={config} title={`ODT N°${data.id_budget}`} date={data?.order_init} />
        </View>

        {/* Contenido principal */}
        <View style={styles.body}>
          {/* Sección 1: Datos del Cliente */}
          <View style={styles.section}>
            <View style={styles.titleContainer}>
              <Text>Datos del Cliente</Text>
            </View>
            <OrderData data={data} />
          </View>

          {/* Sección 2: Items de Trabajo */}
          <View style={styles.section} break>
            <View style={styles.titleContainer}>
              <Text>Items de Trabajo</Text>
            </View>
            <P
              style={{
                fontSize: '11px',
                color: '#34495e',
                lineHeight: 1.5,
                textAlign: 'justify',
                marginBottom: '0.8cm',
              }}
            >
              En la siguiente tabla, se observan los trabajos realizados y equipos involucrados.
            </P>
            <Table columns={columns} data={items} />
          </View>

          {/* Sección 3: Información de Entrega */}
          <View style={[styles.section, styles.signaturesContainer]} wrap={false} break>
            <View style={styles.titleContainer}>
              <Text>Información de Entrega</Text>
            </View>
            <P
              style={{
                fontSize: '11px',
                color: '#34495e',
                lineHeight: 1.5,
                textAlign: 'justify',
                marginBottom: '0.8cm',
              }}
            >
              A continuación, se encuentra la firma y nombre tanto del especialista como de quien
              recibe los trabajos. Esto, cuenta como una constancia firmada de que se finalizó la
              orden de trabajo.
            </P>
            <SignatureBlock
              specialistSignature={specialistSignature}
              recepcionistName={recepcionistName}
              recepcionistSignature={recepcionistSignature}
              recepcionistCharge={recepcionistCharge}
              specialistName={specialistName}
              specialistEspecialidad={specialistEspecialidad}
              specialistCargo={specialistCargo}
              specialistOtros={specialistOtros}
            />
          </View>
        </View>

        {/* Footer fijo */}
        <View style={styles.footer} fixed>
          <Footer config={config} />
        </View>
      </PageA4>
    </Document>
  );
}

export default OrderDocument;
